import { ApplicationInsights, type ICustomProperties, SeverityLevel } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export function initAppInsights() {
  const instrumentationKey = import.meta.env.VITE_APPINSIGHTS_INSTRUMENTATION_KEY;

  if (!instrumentationKey) {
    console.warn('[AppInsights] Missing VITE_APPINSIGHTS_INSTRUMENTATION_KEY');
    return null;
  }

  if (!appInsights) {
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        enableAutoRouteTracking: true,
        disableAjaxTracking: true,
        disableFetchTracking: true,
        disableExceptionTracking: false,
      },
    });
    appInsights.loadAppInsights();
  }
  return appInsights;
}

export function trackAI(message: string, severity?: SeverityLevel) {
  if (!appInsights) return;
  appInsights.trackTrace({ message, severityLevel: severity });
}

export function trackException(error: Error, customProps?: ICustomProperties) {
  if (!appInsights) return;
  appInsights.trackException({ exception: error }, customProps);
}

export function getAppInsights() {
  return appInsights;
}
